import type { FieldOfExperiences } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<FieldOfExperiences>('/field-of-experiences/:id');
